"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DevelopmenMobileCommunicatorView = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable no-console */
const React = __importStar(require("react"));
const features_1 = require("../../features");
const DevelopmenMobileCommunicatorView = () => {
    const [mockMode, setMockMode] = React.useState((0, features_1.isMobileCommunicatorMockMode)());
    const updateMockMode = (value) => {
        (0, features_1.setMobileCommunicatorMockMode)(value);
        setMockMode(value);
    };
    return ((0, jsx_runtime_1.jsx)("section", { children: (0, jsx_runtime_1.jsxs)("label", { children: [(0, jsx_runtime_1.jsx)("input", { onChange: e => updateMockMode(!!e.target.checked), type: "checkbox", checked: mockMode }), "Enable Mock Mode"] }) }));
};
exports.DevelopmenMobileCommunicatorView = DevelopmenMobileCommunicatorView;
//# sourceMappingURL=developmentMobileCommunicatorView.js.map